import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: _vm.dependenciesComponentsStyleList },
    [
      _c(VProgressCircular, {
        staticClass: "primary--text d-block mb-6 mx-auto",
        attrs: {
          size: _vm.preloaderData.size,
          width: _vm.preloaderData.width,
          indeterminate: "",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 text--text text-center" }, [
        _vm._v("\n    Бронируем время на 20 минут...\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }